export default __webpack_public_path__ + "images/close_hover.8e7e7498.svg";